export default "__VITE_PUBLIC_ASSET__b81c7b60__"